<template>
     <div class="card card-dashboard-thirteen"  v-loading='loading' style="height:520px">
        <label class="az-content-label pd-b-20">Membership Age Distribution</label>
        <ChartAge v-if='isChartShow' :chartSeries='chartSeries'/>
    </div>
</template>
<script>
export default {
    name:'boage',
    components: {
        ChartAge : () => import('../charts/ChartAge.vue')
    },
    data(){
        return{
            isChartShow: false,
            brands: [],
            chartSeries:[],
            loading:true
        }
    },
    created(){
        this.getMemberAges()
    },
    watch:{
        chartSeries(newVal){
            if(newVal.length===this.brands.length){
                this.isChartShow = true
                this.loading = false
            }
        }
    },
    methods:{
        getMemberAges(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            let brands = userdetail['brand_list']
            this.brands = brands
            let brandLength = brands.length;
            let colorList = [           
                '#03045e','#0077b6','#00b4d8','#90e0ef','#0a9396','#94d2bd','#e9d8a6','#ee9b00'                                 
            ];
            for (var i = 0; i < brandLength; i++) {
                this.ageRequest(i,brands,colorList)
            }

        },
        ageRequest(i,brands,colorList){
            this.$api.adviserdashboard_api.memberAgeProfile(brands[i][0]).then(response =>{
                    let age_groups = response.data['age_groups']
                    let age_list = age_groups.map(a => a.num_member);
                    
                    this.chartSeries.push({
                        name: brands[i][1],
                        type: 'bar',
                        stack: 'total',
                        itemStyle: {
                            opacity:0.8, 
                            color: colorList[i]
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: age_list.reverse()
                        },
                    )
                    
                    
                })
        }

    }
}

</script>